import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <h2>SSD Rts Site</h2>
  <h3>Description</h3>
  <p>Packages received dwell at sites for greater than network threshold and/or exceeding site volume limits</p>
  <h3>SOP</h3>
  <ol type="A">
    <li>For all "DP Returned - Pending Station Debrief" packages, follow the below steps
      <ol>
        <li>Click into the impacted packages.</li>
        <li>Head to the RTS area and locate the RTS packages from the "pending receive" exceptions cart.</li>
        <li>Verify if the package was debriefed by the DP utilizing their dolphin app. Verify this by checking the package history in SCC and looking for the "self-return" scan.</li>
        <li>Debrief the RTS package.</li>
      </ol>
    </li>
    <li>For all "Station Received - Pending Induct" packages, follow the below steps
      <ol>
        <li>Click into the impacted packages.</li>
        <li>Head into the RTS area and locate the RTS package from the Ready for Induct exceptions cart.</li>
        <li>If the exceptions cart is not in the RTS area, look for the package in the Induction area.</li>
        <li>Induct the RTS package and place on conveyance.</li>
      </ol>
    </li>
  </ol>
  <p>Note: If the debriefed package indicates a cancellation, the package must be RTFC'd and go to RTFC stow (do NOT induct).</p>
</div>`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_RTS_SITE.jsx